
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/inhouse-support",
      function () {
        return require("private-next-pages/cases/inhouse-support/index.tsx");
      }
    ]);
  